import React, { useContext, useMemo, useState } from 'react';
import classnames from 'classnames';
import Config from '@app/dev/config/main';
import { useTranslation } from '@common/hooks/translation';

import { PreferencesContext } from '@common/contexts/preferences';

import { PopupContext } from '@app/dev/contexts/popup';

import './style.scss';

const OddsFormatSelect = () => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);
  const [preferences, setPreferences] = useContext(PreferencesContext);
  const [oddsFormat, setOddFormat] = useState(preferences.oddsFormat);

  const dropdownOptions = useMemo(() => (
    Config.availableOdds
      .filter((item) => item.enabled)
      .map((item) => ({ name: t(item.title), value: item.odds }))
  ), [t]);

  const changeOddType = () => {
    setPreferences({ ...preferences, oddsFormat });
    closePopup();
  };

  return (
    <div className="popup-inner-container">
      <div className="popup-container">
        <div className="popup-title-row">
          <span className="popup-title-row-text">{t('Odds Type')}</span>
        </div>
        <div className="popup-main-wrapper">
          <div className="scrollable-container">
            {dropdownOptions.map((item) => (
              <div
                className={classnames('popup-main-row', {
                  active: item.value === oddsFormat,
                })}
                onClick={() => setOddFormat(item.value)}
              >
                <p key={item.value}>
                  {item.name}
                </p>
                <i
                  className={classnames('global-icon', {
                    'icon-icon-done': item.value === oddsFormat,
                  })}
                />
              </div>
            ))}
          </div>
          <div className="button-section">
            <buttom onClick={closePopup} className="oddType-popup-button close">{t('Cancel')}</buttom>
            <button
              type="submit"
              className="oddType-popup-button confirm"
              onClick={changeOddType}
            >
              {t('Save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OddsFormatSelect;
